// ── SPCore header ──
(function () {
  function boot() {
    document.querySelectorAll('[data-sp-header]').forEach(function (el) {
      if (!el.spHeader) el.spHeader = new SPHeader(el);
    });
  }

  class SPHeader {
    constructor(root) {
      this.root = root;
      this.top = root.querySelector('.sp-header__top');
      this.burger = root.querySelector('[data-sp-burger]');
      this.island = root.querySelector('.sp-header__bottom');
      this.nav = root.querySelector('.sp-header__nav');
      this.rootList = root.querySelector('.sp-header__nav > ul');
      this.megaPanels = Array.from(root.querySelectorAll('.sp-header__submenu--mega'));
      this.scrim = root.querySelector('[data-sp-scrim]');

      this.stickyType = root.dataset.sticky || 'always';
      this.collapse = root.dataset.collapse === 'true';
      this.desktop = window.matchMedia(SPCore.config.mediaQueryUp(990));

      this.lastY = window.scrollY;
      this.dir = 'up';
      this.distance = 0;
      this.threshold = 200;
      this.manual = false;
      this.activeSubmenu = null;

      this.measure = this.measure.bind(this);
      this.onScroll = SPCore.utils.throttle(this.handleScroll.bind(this));
      this.onKeydown = this.onKeydown.bind(this);

      this.init();
    }

    init() {
      this.measure();
      if (window.ResizeObserver) {
        this.ro = new ResizeObserver(this.measure);
        this.ro.observe(this.root);
      }

      if (this.stickyType !== 'none') {
        window.addEventListener('scroll', this.onScroll, { passive: true });
        this.handleScroll();
      }

      if (this.burger) {
        this.burger.addEventListener('click', (e) => {
          e.preventDefault();
          if (this.desktop.matches) {
            this.manual = true;
            clearTimeout(this.manualTimer);
            this.manualTimer = setTimeout(() => { this.manual = false; }, 1500);
            const collapsed = this.root.classList.toggle('is-collapsed');
            this.burger.setAttribute('aria-expanded', String(!collapsed));
          } else {
            this.toggleMenu();
          }
        });
      }

      if (this.scrim) this.scrim.addEventListener('click', () => this.closeMenu());

      this.initSubmenus();

      if (SPCore.pubsub) {
        SPCore.pubsub.subscribe(SPCore.events.breakpointChange, () => {
          if (this.desktop.matches) this.closeMenu();
          else this.resetDrill();
        });
      }

      if (SPCore.settings.designMode) {
        const section = this.root.closest('.shopify-section');
        if (section) {
          ['shopify:section:load', 'shopify:section:unload', 'shopify:section:reorder'].forEach((evt) =>
            section.addEventListener(evt, this.measure)
          );
        }
      }
    }

    /* ── Popup island ── */
    toggleMenu() {
      this.root.classList.contains('is-menu-open') ? this.closeMenu() : this.openMenu();
    }

    openMenu() {
      this.root.classList.add('is-menu-open');
      if (this.burger) this.burger.setAttribute('aria-expanded', 'true');
      this.setHeight(this.rootList);
      document.addEventListener('keydown', this.onKeydown);
      if (SPCore.a11y && this.island) SPCore.a11y.trapFocus(this.island, this.rootList);
    }

    closeMenu() {
      const wasOpen = this.root.classList.contains('is-menu-open');
      this.root.classList.remove('is-menu-open');
      if (this.burger) this.burger.setAttribute('aria-expanded', 'false');
      this.resetDrill();
      if (this.island) this.island.style.height = '';
      document.removeEventListener('keydown', this.onKeydown);
      if (SPCore.a11y) SPCore.a11y.removeTrapFocus(wasOpen && this.burger ? this.burger : null);
    }

    onKeydown(e) {
      if (e.key !== 'Escape') return;
      if (this.activeSubmenu) this.back();
      else this.closeMenu();
    }

    setHeight(panel, full) {
      if (!this.island) return;
      const room = window.innerHeight - this.island.getBoundingClientRect().top - 16;
      const h = full ? room : Math.min(panel ? panel.offsetHeight : 0, room);
      this.island.style.height = h + 'px';
      this.megaPanels.forEach((p) => { p.style.height = full && p === panel ? h + 'px' : ''; });
    }

    /* ── Submenus ── */
    initSubmenus() {
      this.items = Array.from(this.root.querySelectorAll('.sp-header__nav-item.has-submenu'));
      if (!this.items.length) return;
      const delay = parseInt(this.root.dataset.submenuDelay, 10) || 0;
      let closeTimer;

      this.items.forEach((item) => {
        const link = item.querySelector('.sp-header__nav-link');
        const back = item.querySelector('[data-sp-back]');

        item.addEventListener('mouseenter', () => {
          if (!this.desktop.matches) return;
          clearTimeout(closeTimer);
          this.items.forEach((other) => { if (other !== item) other.classList.remove('is-open'); });
          item.classList.add('is-open');
        });
        item.addEventListener('mouseleave', () => {
          if (!this.desktop.matches) return;
          clearTimeout(closeTimer);
          closeTimer = setTimeout(() => item.classList.remove('is-open'), delay);
        });

        if (link) {
          link.addEventListener('click', (e) => {
            if (this.desktop.matches) return;
            e.preventDefault();
            this.drill(item);
          });
        }
        if (back) {
          back.addEventListener('click', (e) => { e.preventDefault(); this.back(); });
        }
      });
    }

    drill(item) {
      this.items.forEach((other) => {
        if (other === item) return;
        other.classList.remove('is-open');
        const l = other.querySelector('.sp-header__nav-link');
        if (l) l.setAttribute('aria-expanded', 'false');
      });
      item.classList.add('is-open');
      const link = item.querySelector('.sp-header__nav-link');
      if (link) link.setAttribute('aria-expanded', 'true');
      this.nav.classList.add('is-drilled');
      this.activeSubmenu = item;

      const panel = item.querySelector('.sp-header__submenu');
      const isMega = panel && panel.classList.contains('sp-header__submenu--mega');
      this.setHeight(panel, isMega);
      const back = item.querySelector('[data-sp-back]');
      if (SPCore.a11y && panel) SPCore.a11y.trapFocus(panel, back || panel);
    }

    back() {
      const fromItem = this.activeSubmenu;
      this.nav.classList.remove('is-drilled');
      if (fromItem) {
        fromItem.classList.remove('is-open');
        const l = fromItem.querySelector('.sp-header__nav-link');
        if (l) l.setAttribute('aria-expanded', 'false');
      }
      this.activeSubmenu = null;
      this.setHeight(this.rootList);
      if (SPCore.a11y && this.island) {
        SPCore.a11y.trapFocus(this.island, (fromItem && fromItem.querySelector('.sp-header__nav-link')) || this.rootList);
      }
    }

    resetDrill() {
      if (this.nav) this.nav.classList.remove('is-drilled');
      if (this.items) {
        this.items.forEach((item) => {
          item.classList.remove('is-open');
          const l = item.querySelector('.sp-header__nav-link');
          if (l) l.setAttribute('aria-expanded', 'false');
        });
      }
      this.activeSubmenu = null;
      this.megaPanels.forEach((p) => { p.style.height = ''; });
    }

    measure() {
      requestAnimationFrame(() => {
        const h = Math.round((this.top || this.root).offsetHeight);
        document.documentElement.style.setProperty('--sp-header-h', h + 'px');
        document.documentElement.style.setProperty('--header-height', h + 'px');
      });
    }

    handleScroll() {
      const y = window.scrollY;
      const dir = y > this.lastY ? 'down' : 'up';
      if (dir !== this.dir) { this.distance = 0; this.dir = dir; }
      else { this.distance += Math.abs(y - this.lastY); }

      requestAnimationFrame(() => {
        const past = this.top.getBoundingClientRect().top <= 0;
        this.root.classList.toggle('is-scrolled', past);

        if (this.collapse && this.desktop.matches) {
          if (past) {
            if (!this.manual) this.root.classList.add('is-collapsed');
          } else {
            this.root.classList.remove('is-collapsed');
            this.manual = false;
          }
        }

        if (this.stickyType === 'scroll-up') {
          if (past && dir === 'down' && this.distance >= this.threshold) this.root.classList.add('is-hide');
          else if (dir === 'up') this.root.classList.remove('is-hide');
        }
      });

      this.lastY = y;
    }
  }

  if (window.SPCore) SPCore.DOMready(boot);
  else document.addEventListener('DOMContentLoaded', boot);
})();
